export const safeString = (value: any) => (value || '').toString();

export const padZeros = (value: string | number, length: number): string => {
  let newValue = safeString(value);

  while ( newValue.length < length ) {
    newValue = '0' + newValue;
  }

  return newValue;
};

export const stringCompare = (str1: string, str2: string): boolean => {
  return safeString(str1).toLowerCase() === safeString(str2).toLowerCase();
};

// when you don't want an exact match and are looking for a partial match
export const stringIncludes = (fullStr: string, partStr: string): boolean => {
  return safeString(fullStr).toLowerCase().includes(safeString(partStr).toLowerCase());
};

export const isString = (value: any): boolean => {
  return typeof value === 'string';
};

export const isBoolean = (value: any): boolean => {
  switch (value) {
    case true:
    case false:
    case 'True':
    case 'true':
    case 'False':
    case 'false':
      return true;
    default:
      return false;
  }
};
